import { FleetUUIDs } from './fleets'

export enum ProcessorStatuses {
  PAID = 'PAID',
  PAID_AT_DMV = 'PAID AT DMV',
  PAID_AT_DMV_C = 'PAID AT DMV C',
  DISMISSED = 'DISMISSED',
  VOIDED = 'VOIDED',
  SUSPENDED = 'SUSPENDED',
  NOT_CLEARED = 'NOT CLEARED',
  WARNING = 'WARNING',
}

export interface ProcessorStatusOption {
  label: string;
  values: ProcessorStatuses[];
}

const Duncan: ProcessorStatusOption[] = [
  { label: 'Paid', values: [ProcessorStatuses.PAID, ProcessorStatuses.PAID_AT_DMV, ProcessorStatuses.PAID_AT_DMV_C] },
  { label: 'Dismissed', values: [ProcessorStatuses.DISMISSED] },
  { label: 'Voided', values: [ProcessorStatuses.VOIDED] },
  { label: 'Suspended', values: [ProcessorStatuses.SUSPENDED] },
  { label: 'Not Cleared', values: [ProcessorStatuses.NOT_CLEARED] },
  { label: 'Warning', values: [ProcessorStatuses.WARNING] },
];

export const ProcessorStatusesByFleet: Record<string, ProcessorStatusOption[]> = {
  [FleetUUIDs.ACTransit]: Duncan,
  [FleetUUIDs.CulverCity]: Duncan,
  [FleetUUIDs.Sacramento]: Duncan,
};
